// extracted by mini-css-extract-plugin
export var textInput = "_ea-0";